/** Shorter display time for quick confirmation toasts (e.g. add to cart). */
export const ADD_TO_CART_TOAST_DURATION = 1500;
